import React, { useState, useEffect, useContext } from 'react';
import '../../../assests/css/customer/SalePageForCustomer/SalePageForCustomer.css';
import { useNavigate } from 'react-router-dom';
import AppContext from '../../../context/AppContext';
import axios from 'axios';

const SalePageForCustomer = () => {
  const navigate = useNavigate();
  const { baseUrl, baseUrlForFiles } = useContext(AppContext);

  const [banners, setBanners] = useState([]);
  const [visible, setVisible] = useState(true);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [dismissed, setDismissed] = useState([]);
  const [timeLeft, setTimeLeft] = useState(null);

  /* ── Fetch active banners ── */
  useEffect(() => {
    axios.get(`${baseUrl}/customer/sale/showActiveBanners`)
      .then(res => {
        const records = res.data.bannerRecords || [];
        setBanners(records);
        setDismissed(new Array(records.length).fill(false));

        // countdown from the nearest endDate
        if (records.length > 0) {
          const nearest = records.reduce((a, b) =>
            new Date(a.endDate) < new Date(b.endDate) ? a : b
          );
          const diff = Math.max(0, Math.floor((new Date(nearest.endDate) - Date.now()) / 1000));
          const days = Math.floor(diff / 86400);
          const hours = Math.floor((diff % 86400) / 3600);
          const minutes = Math.floor((diff % 3600) / 60);
          const seconds = diff % 60;
          setTimeLeft({ days, hours, minutes, seconds });
        }
      })
      .catch(err => console.log(err));
  }, [baseUrl]);

  /* ── Countdown timer ── */
  useEffect(() => {
    if (!timeLeft) return;
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (!prev) return prev;
        let { days, hours, minutes, seconds } = prev;
        if (seconds > 0) seconds--;
        else if (minutes > 0) { minutes--; seconds = 59; }
        else if (hours > 0) { hours--; minutes = 59; seconds = 59; }
        else if (days > 0) { days--; hours = 23; minutes = 59; seconds = 59; }
        else { clearInterval(timer); return { days: 0, hours: 0, minutes: 0, seconds: 0 }; }
        return { days, hours, minutes, seconds };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [!!timeLeft]);

  /* ── Auto-slide ── */
  useEffect(() => {
    if (!visible || banners.length === 0) return;
    const iv = setInterval(() => {
      setCurrentSlide(prev => getNext(prev, dismissed, banners.length));
    }, 4000);
    return () => clearInterval(iv);
  }, [dismissed, visible, banners.length]);

  /* ── Helpers ── */
  const getNext = (from, dis, len) => {
    if (!len) return 0;
    let n = (from + 1) % len;
    for (let i = 0; i < len; i++) {
      if (!dis[n]) return n;
      n = (n + 1) % len;
    }
    return from;
  };

  const getPrev = (from, dis, len) => {
    if (!len) return 0;
    let p = (from - 1 + len) % len;
    for (let i = 0; i < len; i++) {
      if (!dis[p]) return p;
      p = (p - 1 + len) % len;
    }
    return from;
  };

  const handleDismiss = (idx) => {
    const updated = [...dismissed];
    updated[idx] = true;
    setDismissed(updated);
    if (updated.every(d => d)) { setVisible(false); return; }
    setCurrentSlide(getNext(idx, updated, banners.length));
  };

  const pad = n => String(n).padStart(2, '0');

  if (!visible || banners.length === 0) return null;

  const slide = banners[currentSlide];
  if (!slide) return null;

  const imgUrl = `${baseUrlForFiles}/${slide.desktopFile}`;

  return (
    <div className="SaleBanner">
      {/* Background image */}
      <div className="SaleBanner__bg">
        <img key={currentSlide} src={imgUrl} alt={slide.bannerTitle} className="SaleBanner__img" />
        <div className="SaleBanner__overlay" />
      </div>

      {/* Dismiss X */}
      <button className="SaleBanner__close" onClick={() => setVisible(false)}>✕</button>

      {/* Content */}
      <div className="SaleBanner__content">
        <div className="SaleBanner__left">
          <span className="SaleBanner__eyebrow">Limited Time Offer</span>
          <h2 className="SaleBanner__title">{slide.bannerTitle}</h2>
          <button
            className="SaleBanner__btn"
            onClick={() =>
              navigate(
                slide.mlcategory_id
                  ? `/sale-products?category=${slide.mlcategory_id}`
                  : '/sale-products'
              )
            }
          >
            Shop Now
          </button>
          {/* <button className="SaleBanner__btn" onClick={() => navigate('/women')}>
            Shop Now
          </button> */}
        </div>
      </div>

      {/* Countdown — transparent, bottom */}
      {timeLeft && (
        <div className="SaleBanner__countdown">
          <p className="SaleBanner__cdLabel">SALE ENDS IN</p>
          <div className="SaleBanner__timer">
            {[['days', 'DAYS'], ['hours', 'HRS'], ['minutes', 'MINS'], ['seconds', 'SECS']].map(([k, l], i) => (
              <React.Fragment key={k}>
                {i > 0 && <span className="SaleBanner__sep">:</span>}
                <div className="SaleBanner__box">
                  <span className="SaleBanner__val">{pad(timeLeft[k])}</span>
                  <span className="SaleBanner__lbl">{l}</span>
                </div>
              </React.Fragment>
            ))}
          </div>
        </div>
      )}

      {/* Arrows + Dots */}
      <div className="SaleBanner__controls">
        <button className="SaleBanner__arrow" onClick={() => setCurrentSlide(getPrev(currentSlide, dismissed, banners.length))}>‹</button>
        <div className="SaleBanner__dots">
          {banners.map((_, idx) => !dismissed[idx] && (
            <button
              key={idx}
              className={`SaleBanner__dot${idx === currentSlide ? ' SaleBanner__dot--active' : ''}`}
              onClick={() => setCurrentSlide(idx)}
            />
          ))}
        </div>
        <button className="SaleBanner__arrow" onClick={() => setCurrentSlide(getNext(currentSlide, dismissed, banners.length))}>›</button>
      </div>
    </div>
  );
};

export default SalePageForCustomer;